import { Coordinates } from "./Coordinates";
import { StoreSearchType } from "../enums/StoreSearchType";
export class StoreSearchData extends Coordinates {
  constructor(coordinates, productData) {
    super(coordinates.getLatitude(), coordinates.getLongitude());
    if ((productData === null || productData === void 0 ? void 0 : productData.product_ref) || productData) {
      this.productRef = (productData === null || productData === void 0 ? void 0 : productData.product_ref) || productData;
      this.storeSearchType = (productData === null || productData === void 0 ? void 0 : productData.type) && Object.values(StoreSearchType).includes(productData.type) ? productData.type : StoreSearchType.STOCK_AND_DELIVERY;
    }
  }
  getProductRef() {
    return this.productRef || '';
  }
  getStoreSearchType() {
    return this.storeSearchType;
  }
}